import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledMenu, StyledMenuItem } from './LangDropdown.styles';
import { Typography, Dropdown } from 'syngenta-digital-cropwise-react-ui-kit';
import { SUPPORTED_LANGS, NONDDG_SUPPORTED_LANGS } from 'base/constants/supportedLangs';
import { useFlowActions } from '../../context/actions/flowActions';
import { removeQueryParameter } from 'utils/urlSearchParams';

const { Text } = Typography;

interface LangDropdownProps {
  children?: JSX.Element;
  isDDG?: boolean;
  isRecommendationPage?: boolean;
}

const LangDropdown: React.FC<LangDropdownProps> = ({
  children,
  isDDG,
  isRecommendationPage = false,
}) => {
  const { i18n } = useTranslation();
  const [showLangMenu, setShowLangMenu] = useState(false);
  const { setAppLanguage } = useFlowActions();
  const [languageMenu, setLanguageMenu] = useState(NONDDG_SUPPORTED_LANGS);

  const onClickOption = (lang: string) => {
    removeQueryParameter('lang');
    i18n.changeLanguage(lang);
    setShowLangMenu(false);
    setAppLanguage({ language: lang });
  };

  const onOpenChange = (flag: boolean) => {
    setShowLangMenu(flag);
  };

  useEffect(() => {
    const langs = isRecommendationPage && !isDDG
      ? NONDDG_SUPPORTED_LANGS
      : SUPPORTED_LANGS;

    setLanguageMenu(langs);
  }, [isRecommendationPage, isDDG]);

  return (
    <Dropdown
      open={showLangMenu}
      overlay={
        <StyledMenu data-testid="dropdown-menu">
          {languageMenu.map(({ name, value, shortLabel }) => (
            <StyledMenuItem
              onClick={() => onClickOption(value)}
              key={`language-${value}`}
            >
              <Text strong={i18n.language === value}>
                {`${name} (${shortLabel})`}
              </Text>
            </StyledMenuItem>
          ))}
        </StyledMenu>
      }
      trigger={['click']}
      onOpenChange={onOpenChange}
    >
      {children}
    </Dropdown>
  );
};

export default LangDropdown;
